import {
  Box,
  Button,
  ButtonBase,
  CircularProgress,
  Icon,
  IconButton,
  Link,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import CoChipSmall from '../../../shared/components/ui/CoChipSmall';
import UserAvatar from '../../../shared/components/ui/UserAvatar';
import { ConferenceContext } from '../../../shared/context/ConferenceContext';
import { infoList } from '../../../shared/utils/DataFormat';

const componentStyles = makeStyles((theme) => ({
  visitorList: {
    '& > *:nth-child(even)': {
      backgroundColor: theme.palette.background.shadedown_10,
      borderBottomWidth: 1,
      borderBottomColor: theme.palette.background.default,
      borderBottomStyle: 'solid',
    },
  },
  visitorButton: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export const ListVisitors = React.memo(({ isHost, entityId }) => {
  const classes = componentStyles();
  const [visitors, setVisitors] = useState([]);
  const [showVisitorList, toggleVisitorList] = useState(false);
  const { openUserPopup } = useContext(ConferenceContext); // Hämta Context

  const addVisitor = () => {
    axios.post(`/api/visitor/entities/${entityId}/visitors`);
  };
  const loadVisitors = () => {
    axios.get(`/api/visitor/entities/${entityId}/visitors`).then((response) => {
      setVisitors(response.data);
    });
  };

  useEffect(() => {
    if (isHost) {
      loadVisitors();
    }
    addVisitor();
  }, [entityId]);

  return isHost ? (
    <Box pt={1}>
      <Button size="small" onClick={() => toggleVisitorList(!showVisitorList)}>
        {showVisitorList ? 'Hide' : 'Show'} visitors ({visitors.length})
      </Button>
      {showVisitorList && (
        <Box pt={1} className={classes.visitorList}>
          {visitors.map((visitor) => (
            <Box key={visitor.id} p={1}>
              <ButtonBase
                onClick={() => openUserPopup(visitor)}
                className={classes.visitorButton}
              >
                <Box display="flex" alignItems="center">
                  <Box pr={1}>
                    <UserAvatar user={visitor} size="small" />
                  </Box>
                  <Box>
                    {infoList([
                      visitor.full_name,
                      visitor.title,
                      visitor.company,
                      visitor.location_city,
                    ])}
                  </Box>
                </Box>
              </ButtonBase>
              <Box>
                {visitor.tags
                  .map((tag) => (
                    <CoChipSmall
                      size="smaller"
                      key={tag.id}
                      tagtype={tag.type}
                      label={tag.title}
                    />
                  ))
                  .reduce((r, a) => r.concat(', ', a), [])
                  .slice(1)}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  ) : null;
});

ListVisitors.displayName = 'ListVisitors';
